module.exports = __webpack_public_path__ + "static/media/aeromeghLog.570f5d0c.png";